import { formatAsCurrency, getSelectionStatusVerb, generateLinkHtml, } from '../helpers/utilities';
export const variableFunctions = {
    moduleName: (data) => data.user.parabolaModel.storybookModules?.pet || null,
    // Verb to use in display text about the user's Pet plan selection.
    selectionStatusVerbDisplayText: (data) => {
        const { selectionStatus } = data.user.pet;
        return getSelectionStatusVerb(selectionStatus);
    },
    accidentCoverage: (data) => data.plan.accidentCoverage || '',
    illnessCoverage: (data) => data.plan.illnessCoverage || '',
    wellnessCoverage: (data) => data.plan.wellnessCoverage || '',
    deductibleAmtDisplayText: (data) => {
        return data.plan.deductible
            ? formatAsCurrency(data.plan.deductible.data)
            : null;
    },
    coverageLimitDisplayText: (data) => {
        return data.plan.maximumPayout
            ? formatAsCurrency(data.plan.maximumPayout.data)
            : null;
    },
    enrollmentLink: (data) => {
        return generateLinkHtml(data.plan.enrollmentUrl);
    },
    carrierName: (data) => data.plan.carrierName || null,
    externalId: (data) => data.plan.externalId || null,
};
//# sourceMappingURL=petInsurance.js.map